<template>
  <div class="card" :style="{ background: background }">
    <div class="card-image">
      <img :src="data.image" alt="企业资质图片">
    </div>
    <div class="card-inner" >
      <div class="card-title">{{ data.title }}</div>
      <div class="card-desc" v-html="data.desc"></div>
      <div class="card-time">{{ data.created_at }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "honor-card",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    background: {
      type: String,
      default: "#fff",
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  width: 260px;
  height: 330px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  box-sizing: border-box;
  overflow: hidden;
  .card-image {
    width: 260px;
    height: 183px;
    background: #eef0f5;
    img{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .card-inner {
    padding: 10px 20px;
  box-sizing: border-box;

    .card-title {
      font-weight: bold;
      font-size: var(--font-size-default-16);
      color: #424242;
      display: -webkit-box; /* 使用WebKit的盒子模型 */
      -webkit-line-clamp: 1; /* 限制显示两行 */
      -webkit-box-orient: vertical; /* 设置盒子方向为垂直 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
    }
    .card-desc {
      width: 100%;
      font-size: var(--font-size-default-14);
      color: #afafaf;
      // display: -webkit-box; /* 使用WebKit的盒子模型 */
      // -webkit-line-clamp: 2; /* 限制显示两行 */
      // -webkit-box-orient: vertical; /* 设置盒子方向为垂直 */
      // overflow: hidden; /* 超出部分隐藏 */
      // text-overflow: ellipsis; /* 超出部分显示省略号 */
      margin: 7px 0 12px;
    }
    .card-time {
      font-weight: 400;
      font-size:  var(--font-size-default-14);
      color: #5f616c;
    }
  }
}
</style>